export const BASE = '/base';
export const ANALYSIS = '/analysis';
export const SHERLOCK = '/sherlock';
export const AUTH = '/auth';
export const DATA_PIPELINE_ORCHESTRATOR = '/data-pipeline-orchestrator';
